import { useEffect, useMemo, useState } from 'react';
import { dashboardData } from './dashboard-data';
import { fetchDashboardValues } from './dashboard-api';

// Merges live API values into the static dashboard tree.
// Only the `value` field is overridden — trends, icons, images, children stay intact.
const applyValues = (nodes, valueMap) =>
  nodes.map((n) => {
    const next = { ...n };
    if (valueMap[n.id]) next.value = valueMap[n.id];
    if (n.children) next.children = applyValues(n.children, valueMap);
    return next;
  });

export const useDashboardData = () => {
  const [valueMap, setValueMap] = useState({});

  useEffect(() => {
    let cancelled = false;
    fetchDashboardValues().then((map) => {
      if (!cancelled) setValueMap(map);
    });
    return () => {
      cancelled = true;
    };
  }, []);

  return useMemo(() => applyValues(dashboardData, valueMap), [valueMap]);
};
